"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ARROW_OFFSETS = exports.ALIGN_POINTS = void 0;
// (C) 2022 GoodData Corporation
exports.ALIGN_POINTS = [{ align: "cr tl" }, { align: "bc tc" }, { align: "bc tr" }];
exports.ARROW_OFFSETS = { "cr tl": [16, -12], "bc tc": [0, 16], "bc tr": [12, 16] };
//# sourceMappingURL=constants.js.map